<template>
  <div id="select-box">
    <h4 style="font-size: 26px;"><span class="text-red">Stap 1/4</span> - KIES EEN BOX</h4>
    <div v-if="loading" class="text-center">Laden...</div>
    <div class="sd-box-grid mt-4">
      <div v-for="box in orderedBoxes" :key="box.id">
        <div
          class="h-100 position-relative sd-box-card"
          :class="{
            'is-selected': localPickedBox?.id === box.id
          }"
        >
          <div class="img-wrapper position-relative">
            <img :src="box?.acf_fields?.boxpicker_afbeelding?.url ?? box?.images?.[0]?.src" style="border-radius: 10px !important;" :alt="box.title">
            <div class="overlay-gradient"></div>
          </div>
          <div class="position-absolute box-content top-0 start-0 mt-4 ms-4">
            <h5 style="font-size: 20px !important;" class="text-white mb-1 fw-bold pb-0">{{ box.name }}</h5>
            <p class="m-0 mb-1 text-white">{{ box?.acf?.ondertitel }}</p>
            <p class="text-white fs-6">€{{ box.price.toString().replace('.', ',') }}</p>
          </div>
          <div class="position-absolute box-footer bottom-0 w-100 mb-4 px-4">
            <button
              class="w-100 py-2-5 btn btn-primary rounded-pill bg-red border-0 select-box-btn"
              @click="selectBox(box)"
            >Kies deze box</button>
          </div>
        </div>
      </div>
    </div>
    <p v-if="boxError" class="text-danger" ref="boxError">Selecteer een box om door te gaan.</p>
  </div>
</template>

<script setup>
import { ref, watch, defineProps, defineEmits, computed } from 'vue';
import { useRoute } from 'vue-router';

const props = defineProps({
  boxes: Array,
  pickedBox: Object
});

const emit = defineEmits(['pickbox']);
const route = useRoute();
const path = computed(() => route.fullPath);

const loading = ref(false);
const localPickedBox = ref(props.pickedBox);
const boxError = ref(false);

const orderedBoxes = computed(() => {
  return [...props.boxes].sort((a, b) => {
    const aOrder = a.product_options?.box_data?.volgorde;
    const bOrder = b.product_options?.box_data?.volgorde;
    const aHasOrder = aOrder !== undefined && aOrder !== null && aOrder !== '';
    const bHasOrder = bOrder !== undefined && bOrder !== null && bOrder !== '';
    
    if (aHasOrder && bHasOrder) {
      return parseInt(aOrder) - parseInt(bOrder);
    } else if (aHasOrder && !bHasOrder) {
      return -1; // a comes first
    } else if (!aHasOrder && bHasOrder) {
      return 1; // b comes first
    } else {
      const aSize = a.size || 0;
      const bSize = b.size || 0;
      return aSize - bSize;
    }
  });
});

watch(() => props.pickedBox, (newPickedBox) => {
  localPickedBox.value = newPickedBox;
});

const selectBox = (box) => {
  localPickedBox.value = box;
  boxError.value = false;
  emit('pickbox', box);
};

const matchTitleToPath = (box, path) => {
  const pathSlug = path.split('/').filter(Boolean).pop();
  return box.slug === pathSlug;
};

const setActiveBoxFromPath = () => {
  if (!localPickedBox.value) {
    const matchingBox = props.boxes.find(box => matchTitleToPath(box, path.value));
    if (matchingBox) {
      selectBox(matchingBox);
    }
  }
};

watch(() => props.boxes, (newBoxes) => {
  if (newBoxes.length > 0) {
    setActiveBoxFromPath();
  }
});
</script>

<style scoped>
.sd-box-card button {
  font-family: Helvetica, sans-serif;
}

.sd-box-card {
  border: 2px solid transparent;
  border-radius: 12px;
  transition: border-color .15s ease, box-shadow .15s ease, transform .15s ease;
}

.sd-box-card.is-selected {
  border-color: #ff4a4a; 
  box-shadow: 0 0 0 4px rgba(255, 74, 74, 0.4);
  transform: translateY(-1px);
}

/* optional: small checkmark badge */
.sd-box-card.is-selected::after {
  content: "✓";
  position: absolute;
  top: 10px;
  right: 10px;
  width: 28px;
  height: 28px;
  border-radius: 999px;
  background: #ff4a4a;
  color: white;
  display: grid;
  place-items: center;
  font-weight: 700;
  z-index: 3;
}

img {
  width: 100%;
  object-fit: cover;
  height: 250px;
}

.py-2-5 {
  padding-top: 0.8rem;
  padding-bottom: 0.8rem;
}

.opacity-50 {
  opacity: 0.5;
}

.sd-box-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 6px;
}

.img-wrapper {
  position: relative;
}

.overlay-gradient {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 200px; /* Adjust height as needed for the fading effect */
  background: linear-gradient(to bottom, rgba(0, 0, 0, 0.6), transparent);
  border-radius: 10px;
}

@media (max-width: 882px) {
  .sd-box-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .box-content {
    margin-top: 15px !important;
    margin-left: 15px !important;
  }

  .box-footer {
    margin-bottom: 15px !important;
    padding-left: 15px !important;
    padding-right: 15px !important;
  }

  .select-box-btn {
    font-size: 14px;
    padding-top: 0.6rem;
    padding-bottom: 0.6rem;
  }
}

@media (max-width: 400px) {
  .sd-box-grid {
    grid-template-columns: repeat(1, 1fr);
  }
}
</style>
